/* Product gallery: keep slides off the critical path, then warm them so a
   swipe never pays for a 1440px PNG decode mid-animation. */
(function () {
  var WARM_GAP = 90;   // ms between background loads
  var NEIGHBOURS = 2;  // slides either side of the active one, forced immediately

  function slides() {
    var car = document.querySelector('gp-carousel[type="gp-feature-image-carousel"]') ||
              document.querySelector('gp-carousel');
    if (!car) return [];
    return [].slice.call(car.querySelectorAll('img[data-lux-slide]'));
  }

  // gp's autosizer rewrites sizes back to 100vw, so every gallery image asks the
  // CDN for a 1440px file to paint a ~607px box. Pin sizes to the real box.
  function rightSize(img) {
    if (!img || img.dataset.luxSized) return;
    img.dataset.luxSized = '1';
    img.removeAttribute('data-sizes');
    img.sizes = '(max-width: 767px) 100vw, 640px';
  }

  function rightSizeAll() {
    var car = document.querySelector('gp-carousel[type="gp-feature-image-carousel"]') ||
              document.querySelector('gp-carousel');
    if (!car) return;
    [].forEach.call(car.querySelectorAll('img'), rightSize);
  }

  function force(img) {
    if (!img || img.dataset.luxWarm) return;
    img.dataset.luxWarm = '1';
    img.loading = 'eager';
    if (img.decode) img.decode().catch(function () {});
  }

  function warmNeighbours() {
    var list = slides();
    if (!list.length) return;
    var car = list[0].closest('gp-carousel');
    var i = parseInt((car && car.getAttribute('active-index')) || '0', 10) || 0;
    for (var k = i - NEIGHBOURS; k <= i + NEIGHBOURS; k++) {
      var img = list.filter(function (im) { return +im.dataset.luxSlide === k; })[0];
      force(img);
    }
  }

  function warmAll() {
    var list = slides().filter(function (im) { return !im.dataset.luxWarm; });
    (function next() {
      var img = list.shift();
      if (!img) return;
      force(img);
      setTimeout(next, WARM_GAP);
    })();
  }

  function boot() {
    rightSizeAll();
    warmNeighbours();
    // background warm-up only once the page is otherwise idle
    var start = function () { setTimeout(warmAll, 1200); };
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 3000 });
    else setTimeout(start, 2000);

    var car = document.querySelector('gp-carousel[type="gp-feature-image-carousel"]') ||
              document.querySelector('gp-carousel');
    if (car && window.MutationObserver) {
      new MutationObserver(function () { rightSizeAll(); warmNeighbours(); })
        .observe(car, { attributes: true, attributeFilter: ['active-index'] });
    }
    document.addEventListener('pointerdown', function () { rightSizeAll(); warmNeighbours(); }, { passive: true });
  }

  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);
})();
